export default __webpack_public_path__ + "static/1-38-0-breakdown-b7d9b8ae2734bd1b11c1551de640f33c.png";